// extracted by mini-css-extract-plugin
export default {"modalOffer":"ModalOffer_modalOffer__lsXfB","modalOffer__center":"ModalOffer_modalOffer__center__7ZOPc","modalOffer__btn":"ModalOffer_modalOffer__btn__oijAO"};